// extracted by mini-css-extract-plugin
module.exports = {"item":"SignCard_style_item__3rr4m"};